<template>
	<header id="header">
		<div class="hInner header_notice subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to='/dentaltalk'></router-link></div>
				<div class="hLine"></div>
				<div class="hName">덴탈TALK</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="dentalTalk_main">
		<div class="content">
			<div class="contIn">
				<ul class="talkList">
					<li v-for="(item, index) in matchingTalks" :key="index"
						@click="commonjs.talkViewPopup(`${item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_boss_id : item.memberMatching_Lab.mb_boss_id}`)"
						:class="{ 'new': (item?.talk?.allTalks?.[0]?.recv_mb_id === globaljs.mb_boss_id) && item?.talk?.allTalks?.[0]?.is_read === 'N' }">
						<div class="talkImg">
							<img v-if="item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_icon : false || item.memberMatching_Lab ? item.memberMatching_Lab.mb_icon : false"
								:src="`${SERVER_URL}/images/member/${item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_icon : item.memberMatching_Lab.mb_icon}`"
								style="max-width:100%;">
							<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
						</div>
						<div class="talkWrap">
							<div class="talkTit">{{ item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_nick : item.memberMatching_Lab.mb_nick }}</div>
							<div class="talkTxtWrap">
								<div class="talkTxt">
									<p v-if="item?.talk?.allTalks?.length > 0" class="nTit">
										{{ item?.talk?.allTalks?.[0]?.notice === 'Y' ? '새로운 톡 알림이 있습니다.' : commonjs.replaceToBr(commonjs.stripTags(item?.talk?.allTalks?.[0]?.content)) }}
									</p>
									<p v-else class="nTit">시작한 대화가 없습니다.</p>
								</div>
								<p v-if="(item?.talk?.allTalks?.[0]?.recv_mb_id === globaljs.mb_boss_id) && item?.talk?.allTalks?.[0]?.is_read === 'N'" class="newIcon">N</p>
								<div class="talkDate">{{ commonjs.dateFormatYMD(item?.talk?.allTalks?.[0]?.createdAt) }}</div>
							</div>
						</div>
					</li>
				</ul>
				<div v-if="matchingTalks.length < 1">데이터가 없습니다.</div>
			</div>
		</div>
	</section>

</template>

<script>
import header from '../components/layout/header.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

const goto_url = (url) => {
	router.push(url);
}

onMounted(async () => {
	await getMatchingTalks();
});

const matchingTalks = ref([]);

const getMatchingTalks = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	let response = await axios.get(`${SERVER_URL}/api/app/matching/talks`, { params });
console.debug(response.data.result);
	matchingTalks.value = response.data.result;
}
</script>